<div nz-row nzType="flex">
    <div nz-col nzSpan="6">
        <div class="formname" style="font-size: 13px;">{{ formTitle }}</div>
    </div>

    <div nz-col nzSpan="18" style="display: flex; justify-content: flex-end">
        <form nz-form [nzLayout]="'inline'">
            <!-- <nz-form-item>
                <nz-form-control>
                    <nz-date-picker [(ngModel)]="month" style="width: 100%" nzFormat="yyyy" name="selectYear"
                        nzPlaceHolder="Select year" (ngModelChange)="yearChange($event)" nzMode="year"
                        [nzDisabledDate]="disabledDate">
                    </nz-date-picker>
                </nz-form-control>
            </nz-form-item> -->

            <nz-form-item>
                <button nz-button nzType="primary" style="margin-right: 0px" (click)="fireEvent()"
                    [nzLoading]="loadprojectexcel">
                    <i nz-icon nzType="file-excel" nzTheme="outline"></i>
                </button>
            </nz-form-item>
        </form>
    </div>

</div>


<div nz-row>
    <div nz-col nzSpan="24">
        <div nz-row>
            <div nz-col nzSpan="24">


                <nz-table #nzTable class="my-scroll no-wrap1" nzBordered nzShowSizeChanger [nzFrontPagination]="false"
                    [nzData]="employeeData" [nzLoading]="loadingRecords" [nzScroll]="scroll">

                    <thead>
                        <tr>
                            <th nzLeft style="text-align: center; padding: 2px; font-size: 12px;" [rowSpan]="2"
                                nzWidth="150px">
                                <b>Project Name</b>
                            </th>
                            <th style="text-align: center; padding: 2px; font-size: 12px;" [rowSpan]="2"
                                nzWidth="100px">
                                <b>Invoice Raised</b>
                            </th>
                            <th style="text-align: center; padding: 2px; font-size: 12px;" [rowSpan]="2"
                                nzWidth="100px">
                                <b>Received</b>
                            </th>
                            <th style="text-align: center; padding: 2px; font-size: 12px;" [rowSpan]="2"
                                nzWidth="100px">
                                <b>Pending</b>
                            </th>
                            <th style="text-align: center; padding: 5px; font-size: 12px;" [colSpan]="4"
                                *ngFor="let month of months">
                                <b>{{ month }}</b>
                            </th>
                            <th nzRight style="text-align: center; padding: 2px; font-size: 12px;" [rowSpan]="2"
                                nzWidth="140px">
                                <b>Total Billing</b>
                            </th>
                        </tr>
                        <tr>
                            <ng-container *ngFor="let month of months">
                                <th
                                    style="text-align: center; color: black; font-weight: 600; padding: 2px; font-size: 12px;">
                                    Billing</th>
                                <th
                                    style="text-align: center; color: black; font-weight: 600; padding: 2px; font-size: 12px;">
                                    Invoice</th>
                                <th
                                    style="text-align: center; color: black; font-weight: 600; padding: 2px; font-size: 12px;">
                                    Received</th>
                                <th
                                    style="text-align: center; color: black; font-weight: 600; padding: 2px; font-size: 12px;">
                                    Due</th>
                            </ng-container>
                        </tr>
                    </thead>

                    <tbody>
                   
                        <tr *ngFor="let employee of employeeData">
                            <td nzLeft style="text-align: left; font-size: 11px; white-space: pre-line;" nz-tooltip
                            [nzTooltipTitle]="'Project Name: ' + employee.Project_Name">
                            {{ employee.Project_Name?.length > 18 ? employee.Project_Name.slice(0, 18) + '...' : employee.Project_Name }}
                        </td>
                        
                            <td style="text-align: right; padding: 2px; font-size: 11px; white-space: pre-line;"
                                nz-tooltip [nzTooltipTitle]="'Invoice Raised: ' + employee.Invoice_Raised">
                                {{ employee.Invoice_Raised | number: '1.2-2' }}
                            </td>
                            <td style="text-align: right; padding: 2px; font-size: 11px; white-space: pre-line;"
                                nz-tooltip [nzTooltipTitle]="'Received: ' + employee.Received">
                                {{ employee.Received | number: '1.2-2' }}
                            </td>
                            <td style="text-align: right; padding: 2px; font-size: 11px; white-space: pre-line;"
                                nz-tooltip [nzTooltipTitle]="'Pending: ' + employee.Pending">
                                {{ employee.Pending | number: '1.2-2' }}
                            </td>
                            <ng-container *ngFor="let month of months">
                                <td style="text-align: right; padding: 2px; font-size: 11px; white-space: pre-line;"
                                    nz-tooltip
                                    [nzTooltipTitle]="'Billing for ' + month + ': ' + (employee[month + '_Billing'] || 0)">
                                    {{ employee[month + '_Billing']  | number: '1.2-2' || 0 }}
                                </td>
                                <td style="text-align: right; padding: 2px; font-size: 11px; white-space: pre-line;"
                                    nz-tooltip
                                    [nzTooltipTitle]="'Invoice for ' + month + ': ' + (employee[month + '_Invoice'] || 0)">
                                    {{ employee[month + '_Invoice']  | number: '1.2-2' || 0 }}
                                </td>
                                <td style="text-align: right; padding: 2px; font-size: 11px; white-space: pre-line;"
                                    nz-tooltip
                                    [nzTooltipTitle]="'Received for ' + month + ': ' + (employee[month + '_Received'] || 0)">
                                    {{ employee[month + '_Received']  | number: '1.2-2' || 0 }}
                                </td>
                                <td style="text-align: right; padding: 2px; font-size: 11px; white-space: pre-line;"
                                    nz-tooltip
                                    [nzTooltipTitle]="'Due for ' + month + ': ' + (employee[month + '_Due'] || 0)">
                                    {{ employee[month + '_Due']  | number: '1.2-2' || 0 }}
                                </td>
                            </ng-container>
                            <td nzRight
                                style="text-align: right; padding: 2px; font-size: 11px; white-space: pre-line;"
                                nz-tooltip [nzTooltipTitle]="'Total Billing: ' + employee.Total_Billing">
                                {{ employee.Total_Billing | number: '1.2-2' }}
                            </td>
                        </tr>

                        <!-- Footer Row -->
                        <tr style="   
    background-color: #f1f1f1;">
                            <td nzLeft style="text-align: left; font-size: 11px; font-weight: bold;">Total</td>
                            <td
                                style="text-align: center; padding: 2px; font-size: 11px; font-weight: bold; white-space: pre-line;">
                                {{ getColumnTotal('Invoice_Raised') }}
                            </td>
                            <td
                                style="text-align: center; padding: 2px; font-size: 11px; font-weight: bold; white-space: pre-line;">
                                {{ getColumnTotal('Received') }}
                            </td>
                            <td
                                style="text-align: center; padding: 2px; font-size: 11px; font-weight: bold; white-space: pre-line;">
                                {{ getColumnTotal('Pending') }}
                            </td>
                            <ng-container *ngFor="let month of months">
                                <td
                                    style="text-align: center; padding: 2px; font-size: 11px; font-weight: bold; white-space: pre-line;">
                                    {{ getMonthlyTotal(month, 'Billing') }}
                                </td>
                                <td
                                    style="text-align: center; padding: 2px; font-size: 11px; font-weight: bold;white-space: pre-line;">
                                    {{ getMonthlyTotal(month, 'Invoice') }}
                                </td>
                                <td
                                    style="text-align: center; padding: 2px; font-size: 11px; font-weight: bold; white-space: pre-line;">
                                    {{ getMonthlyTotal(month, 'Received') }}
                                </td>
                                <td
                                    style="text-align: center; padding: 2px; font-size: 11px; font-weight: bold; white-space: pre-line;">
                                    {{ getMonthlyTotal(month, 'Due') }}
                                </td>
                            </ng-container>
                            <td nzRight
                                style="text-align: center; padding: 2px; font-size: 11px; font-weight: bold; white-space: pre-line;">
                                {{ getColumnTotal('Total_Billing') }}
                            </td>
                        </tr>
                    </tbody>
                </nz-table>


            </div>
        </div>
    </div>
</div>